module.exports = __webpack_public_path__ + "img/ic-ecran.5fb7108e.svg";